const CONSENT_KEY = "blackfold_cookie_consent_v1"
const CONSENT_ACCEPTED = "accepted"

export const GA_MEASUREMENT_ID = "G-NEBPN3T78P"

export function getAnalyticsConsent() {
  if (typeof window === "undefined") return null
  try {
    return window.localStorage.getItem(CONSENT_KEY)
  } catch {
    return null
  }
}

export function setAnalyticsConsent(value) {
  if (typeof window === "undefined") return
  try {
    window.localStorage.setItem(CONSENT_KEY, value)
  } catch {
    // ignore
  }
}

function ensureGtagBootstrapped() {
  if (typeof window === "undefined") return false

  window.dataLayer = window.dataLayer || []
  window.gtag = window.gtag || function gtag() {
    window.dataLayer.push(arguments)
  }

  return true
}

function markGtagLoaded() {
  if (typeof window === "undefined") return
  window.__blackfoldGtagLoaded = true
}

function isGtagLoaded() {
  if (typeof window === "undefined") return false
  return Boolean(window.__blackfoldGtagLoaded)
}

export function ensureAnalyticsLoaded() {
  if (typeof window === "undefined") return false
  if (getAnalyticsConsent() !== CONSENT_ACCEPTED) return false

  ensureGtagBootstrapped()

  if (isGtagLoaded()) return true

  if (document.querySelector(`script[data-ga4="${GA_MEASUREMENT_ID}"]`)) return true

  const script = document.createElement("script")
  script.async = true
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`
  script.setAttribute("data-ga4", GA_MEASUREMENT_ID)

  script.onload = () => {
    ensureGtagBootstrapped()
    window.gtag("js", new Date())
    window.gtag("config", GA_MEASUREMENT_ID, {
      anonymize_ip: true,
    })
    markGtagLoaded()
  }

  document.head.appendChild(script)
  return true
}

export function trackPageView(pathname, title) {
  if (typeof window === "undefined") return
  if (!ensureAnalyticsLoaded()) return
  if (typeof window.gtag !== "function") return

  window.gtag("event", "page_view", {
    page_location: window.location.href,
    page_path: pathname,
    page_title: title || document.title,
  })
}

export function trackAddToCart({
  productId,
  productName,
  variantId,
  variantName,
  price,
  currency,
  qty,
}) {
  if (typeof window === "undefined") return
  if (!ensureAnalyticsLoaded()) return
  if (typeof window.gtag !== "function") return

  window.gtag("event", "add_to_cart", {
    currency: currency || "EUR",
    value: Number(price || 0) * Number(qty || 1),
    items: [
      {
        item_id: String(variantId || productId || ""),
        item_name: productName || "",
        item_variant: variantName || "",
        price: Number(price || 0),
        quantity: Number(qty || 1),
      },
    ],
  })
}

export const CONSENT_VALUES = {
  accepted: CONSENT_ACCEPTED,
  rejected: "rejected",
}
